import {isRTL} from '../../../../../Localization';
import {keys} from '../../../../../constants/KeyCodes';
import {Column} from '../../../../../stores/Form/Column';

type GridData = {
    columns: Array<Column>;
    currentCellIndex: number;
    rowsCount: number;
    currentRow: number;
    setFocusCell: (colId: number, rowIndex?: number) => void;
    screenRows: number;
    searchModeLevel: number;
};

const getNextCellIndex = (currentCellIndex, columns) => {
    return currentCellIndex < columns.length - 1
        ? columns[currentCellIndex + 1].index
        : columns[0].index;
};

const getPrevCellIndex = (currentCellIndex, columns) => {
    return currentCellIndex > 0
        ? columns[currentCellIndex - 1].index
        : columns[columns.length - 1].index;
};

export const navigateToNextCell = (data: GridData) => {
    const {columns, currentCellIndex, rowsCount, currentRow, setFocusCell} = data;
    const nextCellIndex = getNextCellIndex(currentCellIndex, columns);
    let rowIndex = nextCellIndex === 0 ? currentRow + 1 : currentRow;

    if (rowIndex >= rowsCount) {
        rowIndex = rowsCount - 1;
    }

    setFocusCell(nextCellIndex, rowIndex);
};

export const handleNavigation = (e: KeyboardEvent, data: GridData) => {
    const rtl = isRTL();
    const {
        columns,
        currentCellIndex,
        rowsCount,
        currentRow,
        setFocusCell,
        screenRows,
        searchModeLevel
    } = data;
    const isShiftPress = e.shiftKey;
    const currentColumn = columns[currentCellIndex];

    switch (e.key) {
        case keys.ARROW_LEFT:
            if (currentColumn.editMode || e.altKey) {
                return;
            }
            e.preventDefault();
            const leftCellIndex = rtl
                ? getNextCellIndex(currentCellIndex, columns)
                : getPrevCellIndex(currentCellIndex, columns);
            setFocusCell(leftCellIndex, currentRow);
            break;
        case keys.ARROW_RIGHT:
            if (currentColumn.editMode || e.altKey) {
                return;
            }
            e.preventDefault();

            const rightCellIndex = rtl
                ? getPrevCellIndex(currentCellIndex, columns)
                : getNextCellIndex(currentCellIndex, columns);
            setFocusCell(rightCellIndex, currentRow);
            break;

        case keys.ARROW_UP:
            e.preventDefault();

            const firstRowIndex = 0;
            const upRowIndex = currentRow > firstRowIndex ? currentRow - 1 : rowsCount - 1;

            setFocusCell(currentCellIndex, upRowIndex);
            break;

        case keys.ARROW_DOWN:
            e.preventDefault();

            const lastRowIndex = rowsCount - 1;
            const downRowIndex = currentRow < lastRowIndex ? currentRow + 1 : 0;

            if (currentRow !== downRowIndex) {
                setFocusCell(currentCellIndex, downRowIndex);
            }
            break;
        case keys.ENTER:
            e.preventDefault();
            if (searchModeLevel) {
                break;
            }
            navigateToNextCell(data);
            break;
        case keys.TAB:
            e.preventDefault();

            if (isShiftPress) {
                const nextCellIndex = currentCellIndex > 0 ? currentCellIndex - 1 : 0;
                setFocusCell(nextCellIndex, currentRow);
                break;
            }

            navigateToNextCell(data);
            break;
        case keys.HOME:
            e.preventDefault();
            if (e.ctrlKey) {
                setFocusCell(currentCellIndex, 0);
                break;
            }

            setFocusCell(0, currentRow);
            break;
        case keys.END:
            e.preventDefault();
            if (e.ctrlKey) {
                setFocusCell(currentCellIndex, rowsCount - 1);
                break;
            }

            setFocusCell(columns.length - 1, currentRow);
            break;
        case keys.PAGE_UP:
            e.preventDefault();
            const prevScreenRow = Math.max(currentRow - screenRows, 0);
            setFocusCell(currentCellIndex, prevScreenRow);
            break;
        case keys.PAGE_DOWN:
            e.preventDefault();
            setFocusCell(currentCellIndex, Math.min(currentRow + screenRows, rowsCount - 1));
            break;
        default:
            break;
    }
};
